import { mailIdentity } from './mailDashboardApi';
export async function composerRequest(runtime, owner, url, method = 'GET', body) {
  const identity = await mailIdentity(runtime);
  if (identity.attributes.sub !== owner) throw new Error('Your account changed. Reopen the composer before continuing.');
  const response = await runtime.fetch(url, { method, headers: { Authorization: `Bearer ${identity.token}`, 'Content-Type': 'application/json' }, ...(body ? { body: JSON.stringify(body) } : {}), signal: AbortSignal.timeout(25000) });
  if ((await mailIdentity(runtime)).attributes.sub !== owner) throw new Error('Your account changed. Your editor content has been preserved.');
  const data = await response.json();
  if (!response.ok) throw Object.assign(new Error(data?.error || data?.message || 'Unable to save or load this document.'), { status: response.status });
  if (!data || typeof data !== 'object' || Array.isArray(data)) throw new Error('Unreadable document response.');
  return data;
}
